// extracted by mini-css-extract-plugin
export default {"card":"Card_card__139ax","cardContent":"Card_cardContent__M-Nt7","text":"Card_text__R9Pyo","position":"Card_position__XUZMC"};